<div id="pageLoaderDiv" class="page-loader">
  <div class="centered-div-outer">
    <div class="centered-div-middle">
      <div class="centered-div-inner opening-page">
        <div class="loadingFileSpinner"></div>
        <div>{{ 'PreparingPrintPDF' | translate }}</div>
      </div>
    </div>
  </div>
</div>
